import { render, staticRenderFns } from "./ServiceSource.vue?vue&type=template&id=6c8be8e1&scoped=true&"
import script from "./ServiceSource.vue?vue&type=script&lang=js&"
export * from "./ServiceSource.vue?vue&type=script&lang=js&"
import style0 from "./ServiceSource.vue?vue&type=style&index=0&id=6c8be8e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8be8e1",
  null
  
)

export default component.exports